import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const PatientsApi = createApi({
  reducerPath: "PatientsApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["PATIENTSAPI"],
  endpoints: (build) => ({
    getPatients: build.query({
      query: ({ page, category, searchTerm }) => ({
        url: `/user?page=${page}&searchTerm=${searchTerm || ""}`,
        method: "GET",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
      providesTags: ["PATIENTSAPI"],
    }),

    getPatientsById: build.query({
      query: ({ id }) => ({
        url: `/user/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PATIENTSAPI"],
    }),

    editPatients: build.mutation({
      query: ({ id, data }) => ({
        url: `/user/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["PATIENTSAPI"],
    }),
    getUserByMobile: build.query({
      query: ({ mobile }) => ({
        url: `/user/${mobile}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PATIENTSAPI"],
    }),
    addPatients: build.mutation({
      query: ({ data }) => ({
        url: `/user/register`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["PATIENTSAPI"],
    }),

    deletePatients: build.mutation({
      query: ({ id }) => ({
        url: `/user/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["PATIENTSAPI"],
    }),
    getBookingForUserByMobile: build.query({
      query: ({ mobile }) => ({
        url: `/user-booking/${mobile}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["PATIENTSAPI"],
    }),
  }),
});

export const {
  useGetPatientsQuery,
  useGetPatientsByIdQuery,
  useEditPatientsMutation,
  useAddPatientsMutation,
  useDeletePatientsMutation,
  useGetUserByMobileQuery,
  useGetBookingForUserByMobileQuery,
} = PatientsApi;
